import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export function PageMeta(): JSX.Element {
	const {
		data: { title, image, canonicalUrl, description, hrefLangSlugs, defaultHrefLangSlug, baseUrl },
	} = usePageMeta();

	return (
		<Helmet>
			<link rel="canonical" href={canonicalUrl}></link>
			<title>{title}</title>
			<meta property="title" content={title} />
			<meta name="description" content={description ?? undefined} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:image" content={image} />
			<meta property="og:title" content={title} />
			<meta property="twitter:image" content={image} />
			<meta property="twitter:image:alt" content={title} />
			<meta property="og:type" content="website" />
			{defaultHrefLangSlug && <link hrefLang="en-US" rel="alternate" href={`${baseUrl}${defaultHrefLangSlug.slug}`} />}
			{hrefLangSlugs.map(({ locale, slug }) => (
				<link key={locale} hrefLang={locale} rel="alternate" href={`${baseUrl}${slug}`} />
			))}
		</Helmet>
	);
}
